/**
 * Mirrors VerificationTaskStatus in the backend (Domain/Enums/CommonEnums.cs).
 * Serialized by name via the API's global JsonStringEnumConverter.
 */
export enum VerificationTaskStatus {
  Pending = 'Pending',
  InProgress = 'InProgress',
  Completed = 'Completed',
  Failed = 'Failed',
  Cancelled = 'Cancelled'
}
